/** A receipt's claim code (docs/23 §3.5): 10 characters, printed ABCDE-FGHJK, typed with or without the dash, any case. '' if it isn't one. */
export function normaliseClaim(raw: string | null | undefined): string {
  const c = String(raw ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  return /^[ABCDEFGHJKMNPQRSTUVWXYZ23456789]{10}$/.test(c) ? `${c.slice(0, 5)}-${c.slice(5)}` : '';
}
